import React, { useEffect, useState } from 'react';

type Metrics = {
  rows?: number;
  addr_query_used_rate?: number;
  cp_match_rate?: number;
  avg_addr_lift?: number;
};

function pct(n?: number) {
  if (typeof n !== 'number') return '—';
  return `${Math.round(Math.max(0, Math.min(1, n)) * 100)}%`;
}

export default function AdminDashboard() {
  const [m, setM] = useState<Metrics | null>(null);
  const [hours, setHours] = useState(24);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  async function load() {
    setLoading(true); setErr(null);
    try {
      const origin = typeof window !== 'undefined' ? window.location.origin : '';
      const u = new URL('/admin/metrics', origin); u.searchParams.set('hours', String(hours));
      const r = await fetch(u.toString());
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      const j = await r.json();
      setM(j);
    } catch (e: any) {
      setErr(String(e?.message || e));
    } finally { setLoading(false); }
  }

  useEffect(() => { load(); }, [hours]);

  return (
    <div className="max-w-4xl mx-auto p-4">
      <div className="flex items-center justify-between">
        <h1 className="text-xl font-semibold">Admin • KPIs</h1>
        <div className="flex items-center gap-2">
          <label className="text-sm text-gray-600">Window</label>
          <select value={hours} onChange={(e)=>setHours(Number(e.target.value))} className="border rounded px-2 py-1">
            <option value={1}>1h</option>
            <option value={6}>6h</option>
            <option value={24}>24h</option>
            <option value={72}>72h</option>
          </select>
        </div>
      </div>

      {err && <div className="mt-3 text-sm text-red-700 bg-red-50 border border-red-200 rounded p-2">{err}</div>}

      <div className="mt-4 grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="rounded-xl border p-4">
          <div className="text-xs text-gray-500">Addr Use</div>
          <div className="text-2xl font-semibold">{pct(m?.addr_query_used_rate)}</div>
          <div className="text-xs text-gray-500">of runs used CP/phrase query</div>
        </div>
        <div className="rounded-xl border p-4">
          <div className="text-xs text-gray-500">CP Match</div>
          <div className="text-2xl font-semibold">{pct(m?.cp_match_rate)}</div>
          <div className="text-xs text-gray-500">top candidate’s CP matched OCR</div>
        </div>
        <div className="rounded-xl border p-4">
          <div className="text-xs text-gray-500">Avg Addr Lift</div>
          <div className="text-2xl font-semibold">{typeof m?.avg_addr_lift === 'number' ? `${m!.avg_addr_lift!>=0?'+':''}${m!.avg_addr_lift!.toFixed(2)}` : '—'}</div>
          <div className="text-xs text-gray-500">approx. score lift when addr boosted</div>
        </div>
      </div>

      <div className="mt-6 text-xs text-gray-500">Rows: {m?.rows ?? 0}</div>
    </div>
  );
}
